export const setUser = (state, {user}) => {
  state.user = user
}



// WEBPACK FOOTER //
// ./src/store/firebase-auth/mutations.js